import { render, staticRenderFns } from "./clicks-by-offer-type.vue?vue&type=template&id=6578d5ee"
import script from "./clicks-by-offer-type.vue?vue&type=script&lang=js"
export * from "./clicks-by-offer-type.vue?vue&type=script&lang=js"
import style0 from "./clicks-by-offer-type.vue?vue&type=style&index=0&id=6578d5ee&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports